"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'Logout': 'Log out',
    'Assistance_Title': 'Your Life Jacket',
    'Assistance_Intro': "We're here for you",
    'Assistance_Contact_Phone': 'You can call all us to: 1-855-611-AHOY',
    'Assistance_Contact_Email': 'You can mail us to: firstmate@ahoy.insure',
    'Assistance_Contact_Chat': 'Or you can use the chat',
    'Boats_Policy': 'Policy',
    'Boats_MyBoat': 'My Boat',
    'Boats_MyBoats': 'My Boats',
    'Boats_Policy_ValidFrom': 'Valid from',
    'Boats_Renewal_Number': 'Renewal Number',
    'Boats_Policy_To': 'to',
    'Boats_Policy_AnnualPremium': 'Annual premium',
    'Boats_Policy_PaymentMethod': 'Payment method',
    'Boats_Policy_Payment_Credit_Card': 'Credit Card',
    'Boats_Policy_Payment_ACH': 'Bank Account',
    'Boats_Policy_PaymentStatus': 'Payment status',
    'Boats_Policy_InstallmentPaymentStatus': 'Installment status',
    'Boats_Policy_DownPaymentStatus': 'Down payment status',
    'Boats_Policy_PaymentStatus_InProgress': 'In progress',
    'Boats_Policy_PaymentStatus_PaidFull': 'Paid in full',
    'Boats_Policy_PaymentStatus_Paid': 'Paid',
    'Boats_Policy_Due': 'Due',
    'Boats_Policy_OutOf': 'out of',
    'Boats_Policy_Paid': 'Paid',
    'Boats_Policy_Of': 'of',
    'Billing_Status_Title': 'Billing status',
    'Customer_PhoneNumber': 'Phone number',
    'Customer_Email': 'Email',
    'Customer_Address': 'Address',
    'Customer_Refer_Title': 'Refer a friend',
    'Customer_Refer_Intro': 'Invite your friends to the Ahoy! family so they can get the same great coverage as you',
    'App_Download_Title': 'Download the Ahoy! App',
    'App_Download_Intro': 'Boat safer and manage your policy!',
    'App_Download_Google': 'Get on Google Playstore',
    'App_Download_Apple': 'Get on Apple Store',
    T_Active: 'Active',
    T_Pending_Cancelation: 'Pending Cancelation',
    T_Canceled: 'Canceled',
    T_In_Trial: 'In Trial',
};
